import Vue from 'vue'
import Router from 'vue-router'

import InviteDriver from '@/components/driver/InviteDriver.vue'
import DriverSignup from '@/components/driver/DriverSignup.vue'
import DriverSignupSuccess from '@/components/driver/DriverSignupSuccess.vue'

import InviteUser from '@/components/user/InviteUser.vue'
import InviteSelection from '@/components/invite/InviteSelection.vue'

import CompanySignup from '@/components/company/CompanySignup.vue'
import CompanySignupSuccess from '@/components/company/CompanySignupSuccess.vue'
import CompanySignupPage from '@/components/company/CompanySignupPage.vue'

import PrintBatchDetails from '@/components/job/batch/PrintBatchDetails.vue'
import JobStopAction from '@/components/job/stop-action/JobStopAction.vue'

import Contact from '@/components/contact/Contact.vue'
import ContactSuccess from '@/components/contact/ContactSuccess.vue'

import TrackingWidget from '@/components/tracking-widget/TrackingWidget.vue'

import Onboard from '@/components/onboard/Onboard.vue'
import OnboardSuccess from '@/components/onboard/OnboardSuccess.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/driver/invite',
      name: 'InviteDriver',
      component: InviteDriver
    },
    {
      path: '/driver/signup',
      name: 'DriverSignup',
      component: DriverSignup
    },
    {
      path: '/driver/signup/success',
      name: 'DriverSignupSuccess',
      component: DriverSignupSuccess
    },
    {
      path: '/user/invite',
      name: 'InviteUser',
      component: InviteUser
    },
    {
      path: '/invite',
      name: 'InviteSelection',
      component: InviteSelection
    },
    {
      path: '/company/signup/success',
      name: 'CompanySignupSuccess',
      component: CompanySignupSuccess
    },
    {
      path: '/company/signup/:id',
      name: 'CompanySignup',
      component: CompanySignup
    },
    {
      path: '/job/:id/stop-action/:stop_id',
      name: 'JobStopAction',
      component: JobStopAction,

    },
    {
      path: '/job/batch/print',
      name: 'PrintBatchDetails',
      component: PrintBatchDetails
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/contact/success',
      name: 'ContactSuccess',
      component: ContactSuccess
    },
    {
      path: '/tracking',
      name: 'TrackingWidget',
      component: TrackingWidget
    },
    {
      path: '/company/signup',
      name: 'CompanySignupPage',
      component: CompanySignupPage
    },

    {
      path: '/onboard',
      name: 'Onboard',
      component: Onboard

    },
    {
      path: '/onboard/success',
      name: 'OnboardSuccess',
      component: OnboardSuccess
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js